export default "__VITE_ASSET__C8rAQi3w__"